import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ITrailer } from 'shared/types';
import { MatChip } from '@angular/material/chips';

@Component({
  selector: 'app-trailer-details-header',
  templateUrl: './trailer-details-header.component.html',
  imports: [TranslateModule, MatChip],
})
export class TrailerDetailsHeaderComponent {
  @Input() public trailer!: Pick<ITrailer, 'scacCode' | 'trailerNumber' | 'type' | 'status'>;
}
